module.exports = __webpack_public_path__ + "static/media/card-game-info.f98fa09a.png";